/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Body/Body.css";
import MediaQuery from "react-responsive";
import exclusiveInsights from "../../Images/exclusive-insights.webp";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index";
import parse from "html-react-parser";

const Form = lazy(() => import("../../components/SignUpForm/SignUpForm"));
const Interior = lazy(() => import("../../components/Interior/Interior"));

export default function Body({
  links,
  angelAiLink,
  celligenceLlcLink,
  sunwestLink,
  angelComLink,
}) {
  const imgCDNURL = process.env.REACT_APP_HW_CDN_URL;

  return (
    <>
      <div className="banner">
        <Container fluid className="bannercontainer">
          <Row>
            <div className="userway-div-mobile">
              <UserWayAccessibilityMenu color="white" width={40} height={40} />
            </div>
            <Col sm={12} md={12} xl={7} lg={7}>
              <div className="bannertextstag">
                <p className="mastertitle">
                  Busting the Top Myth <br></br>in Mortgage through Ai
                </p>
                <p className="mastertitlemobile">
                  Busting the Top<br></br> Myth in Mortgage<br></br> through Ai
                </p>
                <div className="mobileflexing">
                  <p className="secndpara">
                    <p className="mastertitle1 ">
                      <span class="dot ps-1">
                        <img
                          src={imgCDNURL + "stopcross.png"}
                          className="dotimg"
                        />
                      </span>{" "}
                      STOP
                      <span className="cross">Repurchases</span>
                    </p>
                    <p className="mastertitle11">
                      <span class="dot ps-1">
                        <img
                          src={imgCDNURL + "tickimg.png"}
                          className="dotimg"
                        />
                      </span>{" "}
                      GO
                      <span class="dotangel ps-1">
                        <img
                          src={imgCDNURL + "tickimg.png"}
                          className="dotimg"
                        />
                      </span>{" "}
                      {parse(angelAiLink)}
                    </p>
                  </p>
                </div>
                <Row className="clumnofdiv">
                  <Col sm={12} md={12} xl={8} lg={8}>
                    <p className="austin ">
                      In an era of compressed margins, {parse(angelAiLink)} has
                      arrived to bust the myth that loan production and
                      compliance is hard and requires vintage and experienced
                      staff.
                    </p>
                  </Col>
                  <Col sm={12} md={12} xl={4} lg={4}>
                    <a
                      href="https://www.askangel.ai"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={imgCDNURL + "angelaidancinglogo.png"}
                        className="img-fluid angeldancingti"
                        alt="Angel Ai Logo"
                      ></img>
                    </a>
                  </Col>
                </Row>
              </div>
              <div className="hoursingtitle">HousingWire Annual 2023</div>
            </Col>
            <MediaQuery query="(min-width: 992px)">
              <Col sm={12} md={12} xl={5} lg={5}>
                <div className="formsection">
                  <Suspense fallback={<div />}>
                    <Form celligenceLlcLink={celligenceLlcLink} sunwestLink={sunwestLink} links={links} />
                  </Suspense>
                </div>
              </Col>
            </MediaQuery>
            <Col>
              <a
                href="https://www.youtube.com/watch?v=8cG2nS_XWfs"
                target="_blank"
                rel="noreferrer/noopener"
              >
                <img
                  src={exclusiveInsights}
                  className="exclusive-insights-mobile"
                  alt="Pavan-Exclusive-Insights"
                />
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <MediaQuery query="(min-width: 992px)">
        <Suspense fallback={<div />}>
          <Interior
            angelAiLink={angelAiLink}
            celligenceLlcLink={celligenceLlcLink}
            sunwestLink={sunwestLink}
            angelComLink={angelComLink}
            links={links}
          />
        </Suspense>
      </MediaQuery>
    </>
  );
}
